import * as React from 'react';

function Tag({ children }) {
  return (
    <div className="inline-flex text-content-secondary bg-tag-bg text-xs leading-4.5 px-[3px] font-medium rounded-[2px]">
      {children}
    </div>
  );
}

export default Tag;
